import { SafeLink } from "@/components/ui/SafeLink";
import { Button } from "@/components/ui/button";
import { SlideFromLeft, SlideFromRight } from "@/components/ui/animations";

export default function Tiles() {
    return (
        <div className="flex flex-col w-full bg-gradient-to-b from-gray-50 to-gray-100 relative overflow-hidden">
            {/* Background decorative elements */}
            <div className="absolute inset-0 pointer-events-none">
                <div className="absolute top-0 left-1/4 w-32 h-32 bg-red-500/3 rounded-full blur-3xl"></div>
                <div className="absolute bottom-1/3 right-1/4 w-48 h-48 bg-gray-900/2 rounded-full blur-3xl"></div>
            </div>

            {/* Full Furniture & Bedding Fitouts*/}
            <SlideFromLeft Component={
                <div id="full-furniture-bedding-fitouts" className=" lg:px-6 xl:px-12 py-14 relative z-10">
                    <div className="flex flex-col  lg:flex-row items-center gap-8 md:gap-10 lg:gap-12 justify-center">
                        <div className="relative group flex-shrink-0 px-4 md:px-6 lg:px-0 transform transition-all duration-700 hover:-translate-y-3 hover:scale-105">
                            <img
                                loading="eager"
                                className="md:w-full lg:max-w-xl xl:max-w-2xl w-full h-full  lg:h-72 xl:h-80 object-cover rounded-2xl shadow-lg group-hover:shadow-2xl transition-all duration-700"
                                src={`${process.env.REACT_APP_BLOB_URL}/www/img/sector/hospitality-accommodation-furniture-bedding-fitout.jpg`}
                                alt="Modern hotel room fit-out with bed, bedding, desk, bedside tables, and décor"
                            />
                            {/* Dark overlay for hover effect */}
                            <div className="absolute inset-0 bg-black/20 rounded-2xl opacity-0 group-hover:opacity-100 transition-opacity duration-500"></div>

                            {/* Animated shine effect */}
                            <div className="absolute inset-0 bg-gradient-to-r from-transparent via-white/20 to-transparent -translate-x-full group-hover:translate-x-full transition-transform duration-1000 rounded-2xl"></div>
                        </div>
                        <div className="flex flex-col gap-10 md:gap-8 lg:px-0 px-4 text-center lg:text-left">
                            <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold text-gray-900 max-w-lg sm:mx-auto md:mx-auto  lg:mx-0 leading-tight">
                                <span className="hero-text-gradient-red">Full Furniture & Bedding </span> Fitouts
                            </h2>
                            <p className="text-lg text-gray-600 leading-relaxed max-w-2xl">
                                Create cohesive, guest-ready spaces across your property — from accommodation rooms to café dining areas. Our hospitality-grade furniture and bedding collections combine commercial durability with inviting aesthetics, perfect for high-traffic use in hotels, motels, Airbnb rentals, student housing, and food service venues. Comfort, style, and performance — all in one place.
                            </p>

                        </div>
                    </div>
                </div>
            } />

            {/* Subtle section separator */}
            <div className="w-full h-px bg-gradient-to-r from-transparent via-gray-300/50 to-transparent mx-auto"></div>

            {/* Hospitality Appliances */}
            <SlideFromRight Component={
                <div id="hospitality-appliances" className="md:pl-0 lg:px-6 xl:px-12 py-14 relative z-10">
                    <div className="flex flex-col lg:flex-row-reverse items-center gap-8 md:gap-10 lg:gap-12 justify-center">
                        <div className="relative group flex-shrink-0 px-4 md:px-6 lg:px-0 transform transition-all duration-700 hover:-translate-y-3 hover:scale-105">
                            <img
                                loading="eager"
                                className="md:w-full lg:max-w-xl xl:max-w-2xl w-full h-full  lg:h-72 xl:h-80 object-cover rounded-2xl shadow-lg group-hover:shadow-2xl transition-all duration-700"
                                src={`${process.env.REACT_APP_BLOB_URL}/www/img/sector/hospitality-accommodation-household-appliances.jpg`}
                                alt="Contemporary hospitality setup featuring essential kitchen appliances"
                            />
                            {/* Dark overlay for hover effect */}
                            <div className="absolute inset-0 bg-black/20 rounded-2xl opacity-0 group-hover:opacity-100 transition-opacity duration-500"></div>

                            {/* Animated shine effect */}
                            <div className="absolute inset-0 bg-gradient-to-r from-transparent via-white/20 to-transparent -translate-x-full group-hover:translate-x-full transition-transform duration-1000 rounded-2xl"></div>
                        </div>
                        <div className="flex flex-col gap-10 md:gap-4 lg:px-0  px-4 text-center lg:text-left">
                            <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold text-gray-900 max-w-lg sm:mx-auto md:mx-auto  lg:mx-0 leading-tight">
                                <span className="hero-text-gradient-red">Hospitality </span> Appliances
                            </h2>
                            <p className="text-lg text-gray-600 leading-relaxed max-w-2xl">
                                Equip both guest rooms and hospitality venues with energy-efficient appliances designed for comfort and function. From in-room bar fridges, kettles, and microwaves to chillers and small-scale appliances for cafés and lounges, we help you deliver seamless guest experiences and support smooth day-to-day operations.
                            </p>
                        </div>
                    </div>
                </div>
            } />

            {/* Subtle section separator */}
            <div className="w-full h-px bg-gradient-to-r from-transparent via-gray-300/50 to-transparent mx-auto"></div>

            {/* TV & Audio Systems */}
            <SlideFromLeft Component={
                <div id="tv-audio-systems" className="lg:px-6 xl:px-12 py-14 relative z-10">
                    <div className="flex flex-col lg:flex-row items-center gap-8 md:gap-10 lg:gap-12 justify-center">
                        <div className="relative group flex-shrink-0 px-4 md:px-6 lg:px-0 transform transition-all duration-700 hover:-translate-y-3 hover:scale-105">
                            <img
                                loading="eager"
                                className="md:w-full lg:max-w-xl xl:max-w-2xl w-full h-full  lg:h-72 xl:h-80 object-cover rounded-2xl shadow-lg group-hover:shadow-2xl transition-all duration-700"
                                src={`${process.env.REACT_APP_BLOB_URL}/www/img/sector/hospitality-accommodation-customised-audio-visual-solutions.jpg`}
                                alt="Bar setting with multiple commercial TV panels displaying live sports"
                            />
                            {/* Dark overlay for hover effect */}
                            <div className="absolute inset-0 bg-black/20 rounded-2xl opacity-0 group-hover:opacity-100 transition-opacity duration-500"></div>

                            {/* Animated shine effect */}
                            <div className="absolute inset-0 bg-gradient-to-r from-transparent via-white/20 to-transparent -translate-x-full group-hover:translate-x-full transition-transform duration-1000 rounded-2xl"></div>
                        </div>

                        <div className="flex flex-col gap-10 md:gap-4 lg:px-0 px-4 text-center lg:text-left">
                            <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold text-gray-900 max-w-lg sm:mx-auto md:mx-auto  lg:mx-0 leading-tight">
                                <span className="hero-text-gradient-red">TV & Audio </span> Systems
                            </h2>
                            <p className="text-lg text-gray-600 leading-relaxed max-w-2xl">
                                Deliver next-level entertainment for guests, diners, or visitors with our integrated TV and audio packages. From quiet hotel rooms to lively restaurant bars and conference zones, our solutions are engineered for seamless installation and standout performance.
                            </p>
                        </div>
                    </div>
                </div>
            } />

            {/* Subtle section separator */}
            <div className="w-full h-px bg-gradient-to-r from-transparent via-gray-300/50 to-transparent mx-auto"></div>

            {/* Secure Guest Casting */}
            <SlideFromRight Component={
                <div id="secure-guest-casting" className="lg:px-6 xl:px-12 py-14 relative z-10">
                    <div className="flex flex-col lg:flex-row-reverse items-center gap-8 md:gap-10 lg:gap-12 justify-center">
                        <div className="relative group flex-shrink-0 px-4 md:px-6 lg:px-0 transform transition-all duration-700 hover:-translate-y-3 hover:scale-105">
                            <img
                                loading="eager"
                                className="md:w-full lg:max-w-xl xl:max-w-2xl w-full h-full lg:h-72 xl:h-80 object-cover rounded-2xl shadow-lg group-hover:shadow-2xl transition-all duration-700"
                                src={`${process.env.REACT_APP_BLOB_URL}/www/img/sector/hospitality-accommodation-secure-casting.jpg`}
                                alt="Hotel TV setup with QR code for guest device casting"
                            />
                            {/* Dark overlay for hover effect */}
                            <div className="absolute inset-0 bg-black/20 rounded-2xl opacity-0 group-hover:opacity-100 transition-opacity duration-500"></div>

                            {/* Animated shine effect */}
                            <div className="absolute inset-0 bg-gradient-to-r from-transparent via-white/20 to-transparent -translate-x-full group-hover:translate-x-full transition-transform duration-1000 rounded-2xl"></div>
                        </div>
                        <div className="flex flex-col gap-10 md:gap-4 lg:px-0 px-4 text-center lg:text-left">
                            <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold text-gray-900 max-w-lg sm:mx-auto md:mx-auto  lg:mx-0 leading-tight">
                                <span className="hero-text-gradient-red">Secure</span> Guest Casting
                            </h2>

                            <p className="text-lg text-gray-600 leading-relaxed max-w-2xl">
                                Let guests stream their own shows — securely and effortlessly. Our guest casting tech enables streaming from personal devices to in-room TVs without the need for logins, remote pairing, or privacy concerns. Perfect for modern travellers and tech-savvy tenants.
                            </p>
                        </div>
                    </div>
                </div>
            } />

            {/* Subtle section separator */}
            <div className="w-full h-px bg-gradient-to-r from-transparent via-gray-300/50 to-transparent mx-auto"></div>

            {/* Commercial Hygiene & Cleaning Essentials */}
            <SlideFromLeft Component={
                <div id="commercial-hygiene-cleaning-essentials" className="lg:px-6 xl:px-12 py-14 relative z-10">
                    <div className="flex flex-col  lg:flex-row items-center gap-8 md:gap-10 lg:gap-12 justify-center">                        
                        <div className="relative group flex-shrink-0 px-4 md:px-6 lg:px-0 transform transition-all duration-700 hover:-translate-y-3 hover:scale-105">
                            <img
                                loading="eager"
                                className="md:w-full lg:max-w-xl xl:max-w-2xl w-full h-full lg:h-72 xl:h-80 object-cover rounded-2xl shadow-lg group-hover:shadow-2xl transition-all duration-700"
                                src={`${process.env.REACT_APP_BLOB_URL}/www/img/sector/hospitality-accommodation-commercial-laundry.jpg`}
                                alt="Commercial washing machine with linens in hospitality setting "
                            />
                            {/* Dark overlay for hover effect */}
                            <div className="absolute inset-0 bg-black/20 rounded-2xl opacity-0 group-hover:opacity-100 transition-opacity duration-500"></div>

                            {/* Animated shine effect */}
                            <div className="absolute inset-0 bg-gradient-to-r from-transparent via-white/20 to-transparent -translate-x-full group-hover:translate-x-full transition-transform duration-1000 rounded-2xl"></div>
                        </div>

                        <div className="flex flex-col gap-10 md:gap-8 lg:px-0 px-4 text-center lg:text-left">
                            <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold text-gray-900 max-w-lg sm:mx-auto md:mx-auto  lg:mx-0 leading-tight">
                                <span className="hero-text-gradient-red">Commercial Hygiene & </span> Cleaning Essentials
                            </h2>
                            <p className="text-lg text-gray-600 leading-relaxed max-w-2xl">
                                Support hygiene and guest wellbeing with professional-grade solutions built for the hospitality environment. From powerful vacuums and air dryers to hand hygiene stations and touchless dispensers, our range is ideal for guest rooms, shared amenities, staff areas, and dining zones.
                            </p>                            
                        </div>
                    </div>
                </div>
            } />
        </div>
    )
}